// If page is loaded faster than 500ms show earlier
jQuery(window).on('load', function() {
	$('.preloader').fadeOut('fast');

	// Timout of 500ms the images to load.
	setTimeout(function() {
		$('.preloader').fadeOut('fast');
	}, 500);

	var $grid = $('.project-items').isotope({
		itemSelector: '.grid-item',
	});

	$('#filters').on('click', 'a', function () {
		var filterValue = $(this).attr('data-filter');
		$grid.isotope({filter: filterValue});
		return false;
	});
});
